import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { EngagementFeedWithUser } from '@epicuro-next/data/engagement/engagement-models';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import {
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys,
  NewsfeedConfigurations,
  NEWSFEED_CONFIGURATIONS_DEFAULT_VALUES,
} from '@epicuro-next/state/news-feed-state';
import { select, Store } from '@ngrx/store';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export abstract class ArticleBaseComponent {
  @Input()
  public article: EngagementFeedWithUser;

  @Input()
  public isAdmin = false;

  @Output()
  public delete = new EventEmitter<void>();

  @Output()
  public articleClick = new EventEmitter<void>();

  public showBin$ = this.store.pipe(
    select(
      selectConfigurationValueFrom<
        NewsfeedConfigurationKeys.EnableNewsfeedDelete,
        NewsfeedConfigurations
      >(
        NAMESPACE_NEWS_FEED,
        NewsfeedConfigurationKeys.EnableNewsfeedDelete,
        NEWSFEED_CONFIGURATIONS_DEFAULT_VALUES[
          NewsfeedConfigurationKeys.EnableNewsfeedDelete
        ],
      ),
    ),
  );

  constructor(protected store: Store) {}
}
